<template>
  <div class="row justify-content-center">
    <div class="col-lg-6 mt-2">
      <idx-card
        :title="`${this.$t('menu.settings.accessProfile.profileList')}`"
      >
        <div class="row">
          <div class="col-12">
            <b-table striped :items="this.allPermissions" :fields="fields">
              <template v-slot:cell(options)="row">
                <div
                  v-if="
                    row.item.type === 'admin' || row.item.type === 'analyst' || row.item.type === 'admin-access'
                  "
                >
                  -
                </div>
                <div v-else>
                  <button
                    class="btn btn-outline-primary"
                    style="display: inline;"
                    v-b-modal="`modalEditProfile${row.item._id}`"
                  >
                    <font-awesome-icon :icon="['fas', 'pen']" />
                  </button>
                  <button
                    class="btn btn-outline-danger"
                    style="display: inline;"
                    @click="deleteProfile(row.item._id)"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-alt']" />
                  </button>
                  <button
                    class="btn btn-outline-primary"
                    v-b-modal="`modal-report-profile-${row.item._id}`"
                  >
                    <font-awesome-icon :icon="['fas', 'bolt']" />
                  </button>
                  <b-modal
                    :id="`modal-report-profile-${row.item._id}`"
                    :title="`${$t('acessProfileTranslateUpdate.modaltitle')}`"

                    size="md"
                  >
                    <modalReportProfile :profile="row.item" />
                  </b-modal>
                  <b-modal
                    :id="`modalEditProfile${row.item._id}`"
                    title="Editar Perfil"
                    size="xl"
                    @ok="saveProfile"
                    @hide="setStateDefault"
                  >
                    <modalProfile :profile="row.item" />
                  </b-modal>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-primary" v-b-modal.modalProfile>
              {{ this.$t('menu.settings.accessProfile.buttonNewProfile') }}
            </button>

            <b-modal
              id="modalProfile"
              :title="`${this.$t(
                'menu.settings.accessProfile.registerNewProfile',
              )}`"
              size="xl"
              @ok="saveProfile"
            >
              <modalProfile />
            </b-modal>
          </div>
        </div>
      </idx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import modalProfile from './modal-profile';
import modalEditProfile from './modal-edit-profile';
import modalReportProfile from './modal-report-profile';
import EventBus from '../../../../eventBus';

export default {
  name: 'profiles',
  data() {
    return {
      fields: [],
    };
  },

  components: {
    modalProfile,
    modalEditProfile,
    modalReportProfile,
    IdxCard,
  },

  computed: {
    ...mapState('profiles', ['allPermissions']),
  },

  methods: {
    ...mapActions('profiles', [
      'deletePermissions',
      'getProfiles',
      'setStateDefault',
    ]),
    saveProfile() {
      EventBus.$emit('save-profile');
    },
    deleteProfile(profileId) {
      const obj = {
        profileId,
        token: JSON.parse(localStorage.getItem('_indecx')).token,
      };

      const title = this.$t('menu.settings.accessProfile.removeProfile');
      const icon = 'warning';
      const buttons = [
        this.$t('menu.settings.accessProfile.buttonCancel'),
        this.$t('menu.settings.accessProfile.buttonRemove'),
      ];
      const dangerMode = true;

      swal({ title, icon, buttons, dangerMode }).then((data) => {
        if (data) {
          this.deletePermissions(obj);

          swal(this.$t('menu.settings.accessProfile.removed'), {
            icon: 'success',
          }).then(() => {
            this.getProfiles({
              token: JSON.parse(localStorage.getItem('_indecx')).token,
              companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            });
          });
        }
      });
    },
  },

  created() {
    this.getProfiles({
      token: JSON.parse(localStorage.getItem('_indecx')).token,
      companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
    });

    this.fields = [
      {
        key: 'name',
        label: this.$t('menu.settings.accessProfile.nameProfile'),
      },
      { key: 'options', label: this.$t('menu.settings.accessProfile.options') },
    ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.input-area {
  display: flex;
  flex-direction: row;
}

// .header {
//   background-color: #72bcd4;
//   color: #fff;
//   padding: 10px 0;
//   border-top-left-radius: 5px;
//   border-top-right-radius: 5px;
// }

// .body {
//   padding: 20px 0;
//   border: 1px solid #ccc;
//   border-top: 0;
//   border-bottom-left-radius: 5px;
//   border-bottom-right-radius: 5px;
// }
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/profiles/index.vue